// extracted by mini-css-extract-plugin
export var dropdownContainer = "_4s-5";
export var imageContainer = "_4s-4";
export var metricsGrid = "_4s-2";
export var productDetailContainer = "_4s-1";
export var productListContainer = "_4s-0";
export var subscriberTableContainer = "_4s-3";